/**
 * Vuex Store 配置文件
 * 
 * 主要功能：
 * 1. 管理路由状态和滚动位置
 * 2. 与 localStorage 同步数据
 * 3. 支持跨标签页数据同步
 */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// localStorage 存储键名定义
const STORAGE_KEY_ROUTE = 'sync_master_route';    // 路由存储键
const STORAGE_KEY_SCROLL = 'sync_master_scroll';  // 滚动位置存储键（JSON格式）

// Vuex Store 配置
const store = new Vuex.Store({
  state: {
    /**
     * 当前路由路径
     */
    route: '/',

    /**
     * 当前标签页唯一标识
     */
    tabId: '#' + Math.random().toString(36).substring(2, 8).toUpperCase(),

    /**
     * 滚动位置状态（JSON格式存储）
     */
    scrollPosition: {
      x: 0,
      y: 0
    }
  },

  mutations: {
    SET_ROUTE (state, value) {
      state.route = value;
    },

    SET_SCROLL_POSITION (state, position) {
      state.scrollPosition = { ...position };
    }
  },

  actions: {
    /**
     * 初始化：从localStorage读取数据并恢复状态
     */
    initFromLocalStorage ({ commit }) {
      // 恢复路由状态
      let storedRoute = localStorage.getItem(STORAGE_KEY_ROUTE);
      if (storedRoute !== null) {
        commit('SET_ROUTE', storedRoute);
      } else {
        commit('SET_ROUTE', '/');
        localStorage.setItem(STORAGE_KEY_ROUTE, '/');
      }

      // 恢复滚动位置状态
      let storedScroll = localStorage.getItem(STORAGE_KEY_SCROLL);
      if (storedScroll !== null) {
        try {
          const scrollData = JSON.parse(storedScroll);
          commit('SET_SCROLL_POSITION', scrollData);
        } catch (e) {
          console.error('Failed to parse stored scroll data:', e);
        }
      }
    },

    /**
     * 更新路由
     */
    updateRoute ({ commit }, newRoute) {
      commit('SET_ROUTE', newRoute);
      localStorage.setItem(STORAGE_KEY_ROUTE, newRoute);
    },

    /**
     * 清除所有数据存储键（保留路由）
     */
    clearAllData ({ commit }) {
      commit('SET_SCROLL_POSITION', { x: 0, y: 0 });
      localStorage.removeItem(STORAGE_KEY_SCROLL);
    },

    /**
     * 更新滚动位置
     */
    updateScrollPosition ({ commit, state }, position) {
      commit('SET_SCROLL_POSITION', position);
      localStorage.setItem(STORAGE_KEY_SCROLL, JSON.stringify(state.scrollPosition));
    },

    /**
     * 同步来自其他标签页的storage变更
     */
    syncFromStorage ({ commit }, { key, newValue }) {
      if (key === STORAGE_KEY_ROUTE) {
        commit('SET_ROUTE', newValue !== null ? newValue : '/');
      } else if (key === STORAGE_KEY_SCROLL) {
        try {
          const scrollData = JSON.parse(newValue);
          commit('SET_SCROLL_POSITION', scrollData);
        } catch (e) {
          console.error('Failed to parse scroll data:', e);
        }
      }
    }
  },

  getters: {
    route: state => state.route,
    tabId: state => state.tabId,
    scrollPosition: state => state.scrollPosition
  }
});

// 导出 Vuex Store
export default store;
